import type {
  AncillaryOptionsCabinBagsCheckoutQuery,
  CabinBagsSelection,
  Money,
  Segment,
} from '@/generated/graphql';
import type { CompletedSegment } from '@/components/FlightSummary/Segment/resolver';
import segmentResolver from '@/components/FlightSummary/Segment/resolver';

const getSegmentsList = (legs): Array<Segment> =>
  legs?.map(({ segments }) => segments[0]);
interface Summary {
  isRoundTrip: boolean;
  isMultiTrip: boolean;
  segments: Array<CompletedSegment>;
}

export const hasCabinBagAdded = (
  segment: CompletedSegment,
  cabinBagsSelections: Array<CabinBagsSelection>
): boolean =>
  segment.sections.every((section) =>
    cabinBagsSelections.some(
      (cabinBag) =>
        cabinBag.segment === Number(segment.id) &&
        cabinBag.section === Number(section.id)
    )
  );

export const getPenaltyFee = (
  segment: CompletedSegment,
  cabinBags: AncillaryOptionsCabinBagsCheckoutQuery['ancillaryOptions']['cabinBags']
): Money | null => {
  const segmentId = Number(segment.id);
  const hasFullCoverage = segment.sections.every((section) =>
    cabinBags.some(
      (cabinBagOption) =>
        cabinBagOption &&
        cabinBagOption.segment === segmentId &&
        cabinBagOption.section === Number(section.id)
    )
  );
  if (!hasFullCoverage) return null;
  return (
    cabinBags.find(
      (cabinBagOption) => cabinBagOption && cabinBagOption.segment === segmentId
    )?.carrierConfiguration?.penaltyFee ?? null
  );
};

export default function summaryResolver(legs): Summary {
  const segments = getSegmentsList(legs);
  const segmentParsed = segments?.map(segmentResolver);
  const isRoundTrip =
    segmentParsed?.length === 2 &&
    JSON.stringify(segmentParsed?.[0].departure) ===
      JSON.stringify(segmentParsed?.[1].destination) &&
    JSON.stringify(segmentParsed?.[1].departure) ===
      JSON.stringify(segmentParsed?.[0].destination);
  const isMultiTrip = segmentParsed?.length > 1 && !isRoundTrip;
  return {
    isRoundTrip: isRoundTrip,
    isMultiTrip: isMultiTrip,
    segments: segmentParsed,
  };
}
